import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/firestore';

// Initialize Firebase
export const config = {
	apiKey: 'AIzaSyDZPiv_noVBtMzUumMQ7rhrEfyoUq74KvA',
	authDomain: 'admin-supportintel.firebaseapp.com',
	databaseURL: 'https://admin-supportintel-default-rtdb.firebaseio.com',
	projectId: 'admin-supportintel',
	storageBucket: 'admin-supportintel.firebasestorage.app',
	messagingSenderId: '380548403927',
	appId: '1:380548403927:web:1bed834d2d01a82aa8d692',
	measurementId: 'G-7MWJWWDLEE',
};

firebase.initializeApp(config);

const db = firebase.firestore();

export { db };
